export function normalizeSubscriptions(data) {
  if (!Array.isArray(data)) throw new Error("Invalid subscription response");
  // The API returns mysql2's [rows, fieldMetadata] tuple.
  const records = Array.isArray(data[0]) ? data[0] : data;
  return records.map((record) => {
    const discount = Number(String(record.discount ?? "").replace(/%$/, "").trim());
    if (!record.subscription_id || !record.subscription_type?.trim() ||
        record.discount == null || record.discount === "" ||
        !Number.isFinite(discount) || discount < 0 || discount > 100) {
      throw new Error("Invalid subscription plan");
    }
    let packages = record.subscription_package;
    if (typeof packages === "string") {
      try { packages = JSON.parse(packages); } catch { packages = null; }
    }
    return { ...record, discount, subscription_package: packages };
  });
}

export function subscriptionPayload(plan) {
  const [normalized] = normalizeSubscriptions([plan]);
  return {
    is_subscribed: true,
    subscription_type: normalized.subscription_type,
    subscription_discount: normalized.discount,
  };
}

export function subscriptionError(error) {
  if ([401, 403].includes(error.response?.status)) return "Please sign in again to manage your subscriptions.";
  if (error.code === "ECONNABORTED" || !error.response) return "We couldn't confirm the update. Refresh your plans before trying again.";
  return "Your subscription could not be saved. Please try again.";
}
